export default class RequestFormTitleController {

  constructor() {}

  showHourly() {
    return this.isHourly;
  }

  showCreateVacationTitle() {
    return this.isVacation && !this.isEdit;
  }

  showEditVacationTitle() {
    return this.isVacation && this.isEdit;
  }

  showCreateAbsenceTitle() {
    return this.isAbsence && !this.isEdit && !this.isEditSickness;
  }

  showEditAbsenceTitle() {
    return this.isAbsence && this.isEdit && !this.isEditSickness;
  }

  showSicknessTitle() {
    return this.isEditSickness;
  }

}



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/requestForm/requestFormTitle/requestFormTitle.controller.js